import React, { useState, useRef, useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import {
  convertToHTML,
  fetchData,
  getAPIEndpoint,
  getCookie,
  getMessage,
  getQuestions,
  setCookie,
  copyContent,
  isMobile,
} from "./Utils";
import ChatIcon from "./icon.png";
import HeaderBG from "./header.png";
import SendIcon from "./send.svg";
import PhoneIcon from "./phone.svg";
import Input from "./Input";

const Questions = ({ token, message, setMessage, handleSendMessage }) => {
  const questions = getQuestions(token);

  useEffect(() => {
    if (message) {
      let checkMessageClick = false;
      for (let index = 0; index < questions.length; index++) {
        if (questions[index] === message) {
          checkMessageClick = true;
        }
      }
      if (checkMessageClick) handleSendMessage();
    }
  }, [message]);

  const submitQuestion = (que) => {
    setMessage(que);
  };

  return (
    <ul className="questions">
      {questions.map((question, index) => (
        <li key={index} onClick={() => submitQuestion(question)}>
          <img src="/agent/elec.svg" />
          <div>{question}</div>
        </li>
      ))}
    </ul>
  );
};

const SupportHTML = () => (
  <ul className="p-block">
    <li>
      <a href="tel:18001216808">
        <div className="grid">
          <label>Support</label>
          <div className="message">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path
                d="M10.0404 8.37377L11.5702 9.90349C11.8076 10.1409 11.8076 10.5258 11.5702 10.7632C10.2867 12.0467 8.25475 12.1911 6.80266 11.102L6.06418 10.5481C4.69501 9.52126 3.47874 8.30499 2.45187 6.93582L1.898 6.19734C0.808938 4.74525 0.953343 2.71332 2.23682 1.42985C2.47422 1.19245 2.85912 1.19245 3.09651 1.42985L4.62623 2.95956C5.01675 3.35008 5.01675 3.98325 4.62623 4.37377L4.18116 4.81884C4.07297 4.92703 4.04615 5.09231 4.11458 5.22916C4.90568 6.81137 6.18863 8.09432 7.77084 8.88542C7.90769 8.95385 8.07297 8.92703 8.18116 8.81884L8.62623 8.37377C9.01675 7.98325 9.64992 7.98325 10.0404 8.37377Z"
                stroke="#79747E"
              />
            </svg>{" "}
            1800 121 6808
          </div>
        </div>
      </a>
      <a role="button" onClick={() => copyContent("1800 121 6808")}>
        <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
          <path
            d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
            fill="#8F8F8F"
          />
        </svg>
      </a>
    </li>
    <li>
      <a href="tel:1800120332222">
        <div className="grid">
          <label>Sales</label>
          <div className="message">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path
                d="M10.0404 8.37377L11.5702 9.90349C11.8076 10.1409 11.8076 10.5258 11.5702 10.7632C10.2867 12.0467 8.25475 12.1911 6.80266 11.102L6.06418 10.5481C4.69501 9.52126 3.47874 8.30499 2.45187 6.93582L1.898 6.19734C0.808938 4.74525 0.953343 2.71332 2.23682 1.42985C2.47422 1.19245 2.85912 1.19245 3.09651 1.42985L4.62623 2.95956C5.01675 3.35008 5.01675 3.98325 4.62623 4.37377L4.18116 4.81884C4.07297 4.92703 4.04615 5.09231 4.11458 5.22916C4.90568 6.81137 6.18863 8.09432 7.77084 8.88542C7.90769 8.95385 8.07297 8.92703 8.18116 8.81884L8.62623 8.37377C9.01675 7.98325 9.64992 7.98325 10.0404 8.37377Z"
                stroke="#79747E"
              />
            </svg>{" "}
            1800 120 33 2222
          </div>
        </div>
      </a>
      <a role="button" onClick={() => copyContent("1800 120 33 2222")}>
        <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
          <path
            d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
            fill="#8F8F8F"
          />
        </svg>
      </a>
    </li>
    <li>
      <a href="mailto:service@jaquar.com">
        <div className="grid">
          <label>Email</label>
          <div className="message">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect
                x="2.66669"
                y="4"
                width="10.6667"
                height="8"
                rx="2"
                stroke="#79747E"
              />
              <path
                d="M2.66669 6L7.10559 8.21945C7.66865 8.50098 8.33139 8.50098 8.89445 8.21945L13.3334 6"
                stroke="#79747E"
              />
            </svg>{" "}
            service@jaquar.com
          </div>
        </div>
      </a>
      <a role="button" onClick={() => copyContent("service@jaquar.com")}>
        <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
          <path
            d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
            fill="#8F8F8F"
          />
        </svg>
      </a>
    </li>
  </ul>
);

const QuestionsNew = ({
  token,
  message,
  setMessage,
  setMessages,
  getCurrentTime,
  handleSendMessage,
  sessionData,
  threadId,
}) => {
  const [questionClicked, setQuestionClicked] = useState(false);

  useEffect(() => {
    if (message && questionClicked) {
      handleSendMessage();
      setQuestionClicked(false);
    }
  }, [message, questionClicked]);

  const submitQue = (text) => {
    switch (text) {
      case "product":
        setQuestionClicked(true);
        setMessage(
          "What products does Essco Bathware offer? Share top 5 picks"
        );
        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message:
              "What products does Essco Bathware offer? Share top 5 picks",
            sender_type: "user",
          },
          true
        );
        break;
      case "dealer":
        setQuestionClicked(true);
        setMessage("Find dealers near me");
        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "Find dealers near me",
            sender_type: "user",
          },
          true
        );
        break;
      case "brochure": {
        const html = `<p>Sure. You can check our product brochure here: <a href="https://www.catalogue.esscobathware.com/essco-new-catalogue/page/1" target="_blank">https://www.catalogue.esscobathware.com/essco-new-catalogue/page/1 <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2.25 2.25V1.75H1.75V2.25H2.25ZM9.39645 10.1036C9.59171 10.2988 9.90829 10.2988 10.1036 10.1036C10.2988 9.90829 10.2988 9.59171 10.1036 9.39645L9.39645 10.1036ZM2.75 8.25V2.25H1.75V8.25H2.75ZM2.25 2.75H8.25V1.75H2.25V2.75ZM1.89645 2.60355L9.39645 10.1036L10.1036 9.39645L2.60355 1.89645L1.89645 2.60355Z" fill="#0079FF"/><path d="M3 11.25V11.25C3 11.947 3 12.2955 3.05764 12.5853C3.29436 13.7753 4.22466 14.7056 5.41473 14.9424C5.70453 15 6.05302 15 6.75 15H9C11.8284 15 13.2426 15 14.1213 14.1213C15 13.2426 15 11.8284 15 9V6.75C15 6.05302 15 5.70453 14.9424 5.41473C14.7056 4.22466 13.7753 3.29436 12.5853 3.05764C12.2955 3 11.947 3 11.25 3V3" stroke="#0079FF" stroke-linecap="round"/></svg></a></p><br/>If you need further assistance, feel free to ask!`;

        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "View Product Brochure",
            sender_type: "user",
          },
          true
        );
        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: html,
            sender_type: "agent",
          },
          true
        );

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "View Product Brochure",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: (
              <div
                className="d-flex siml"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            ),
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      case "warranty": {
        const html = `<p>To protect your purchase with warranty coverage, you can register your product here: <a href="https://support.jaquar.com/Warranty/Validate" target="_blank">https://support.jaquar.com/Warranty/Validate <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2.25 2.25V1.75H1.75V2.25H2.25ZM9.39645 10.1036C9.59171 10.2988 9.90829 10.2988 10.1036 10.1036C10.2988 9.90829 10.2988 9.59171 10.1036 9.39645L9.39645 10.1036ZM2.75 8.25V2.25H1.75V8.25H2.75ZM2.25 2.75H8.25V1.75H2.25V2.75ZM1.89645 2.60355L9.39645 10.1036L10.1036 9.39645L2.60355 1.89645L1.89645 2.60355Z" fill="#0079FF"/><path d="M3 11.25V11.25C3 11.947 3 12.2955 3.05764 12.5853C3.29436 13.7753 4.22466 14.7056 5.41473 14.9424C5.70453 15 6.05302 15 6.75 15H9C11.8284 15 13.2426 15 14.1213 14.1213C15 13.2426 15 11.8284 15 9V6.75C15 6.05302 15 5.70453 14.9424 5.41473C14.7056 4.22466 13.7753 3.29436 12.5853 3.05764C12.2955 3 11.947 3 11.25 3V3" stroke="#0079FF" stroke-linecap="round"/></svg></a></p><br/>If you need further assistance, feel free to ask!`;

        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "Register for warranty",
            sender_type: "user",
          },
          true
        );
        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: html,
            sender_type: "agent",
          },
          true
        );

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "Register for warranty",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: (
              <div
                className="d-flex siml"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            ),
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      case "service_request": {
        const html = `<p>To register a service request for your product, please visit: <a href="https://support.jaquar.com/Service/Support" target="_blank">https://support.jaquar.com/Service/Support <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2.25 2.25V1.75H1.75V2.25H2.25ZM9.39645 10.1036C9.59171 10.2988 9.90829 10.2988 10.1036 10.1036C10.2988 9.90829 10.2988 9.59171 10.1036 9.39645L9.39645 10.1036ZM2.75 8.25V2.25H1.75V8.25H2.75ZM2.25 2.75H8.25V1.75H2.25V2.75ZM1.89645 2.60355L9.39645 10.1036L10.1036 9.39645L2.60355 1.89645L1.89645 2.60355Z" fill="#0079FF"/><path d="M3 11.25V11.25C3 11.947 3 12.2955 3.05764 12.5853C3.29436 13.7753 4.22466 14.7056 5.41473 14.9424C5.70453 15 6.05302 15 6.75 15H9C11.8284 15 13.2426 15 14.1213 14.1213C15 13.2426 15 11.8284 15 9V6.75C15 6.05302 15 5.70453 14.9424 5.41473C14.7056 4.22466 13.7753 3.29436 12.5853 3.05764C12.2955 3 11.947 3 11.25 3V3" stroke="#0079FF" stroke-linecap="round"/></svg></a></p><br/>If you need further assistance, feel free to ask!`;
        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "Register a service request",
            sender_type: "user",
          },
          true
        );
        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: html,
            sender_type: "agent",
          },
          true
        );

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "Register a service request",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: (
              <div
                className="d-flex siml"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            ),
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      case "assistant": {
        const html = (
          <div className="support">
            <p>
              If you need any help with a new purchase, we're just a call away.{" "}
              <br />
              <br />
              Feel free to reach out to us anytime between Monday-Saturday 9:00
              AM to 6:00 PM.
            </p>
            <ul className="p-block">
              <li onClick={() => copyContent("1800 121 6808")}>
                <div className="grid">
                  <label>Support</label>
                  <div className="message">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                      <path
                        d="M10.0404 8.37377L11.5702 9.90349C11.8076 10.1409 11.8076 10.5258 11.5702 10.7632C10.2867 12.0467 8.25475 12.1911 6.80266 11.102L6.06418 10.5481C4.69501 9.52126 3.47874 8.30499 2.45187 6.93582L1.898 6.19734C0.808938 4.74525 0.953343 2.71332 2.23682 1.42985C2.47422 1.19245 2.85912 1.19245 3.09651 1.42985L4.62623 2.95956C5.01675 3.35008 5.01675 3.98325 4.62623 4.37377L4.18116 4.81884C4.07297 4.92703 4.04615 5.09231 4.11458 5.22916C4.90568 6.81137 6.18863 8.09432 7.77084 8.88542C7.90769 8.95385 8.07297 8.92703 8.18116 8.81884L8.62623 8.37377C9.01675 7.98325 9.64992 7.98325 10.0404 8.37377Z"
                        stroke="#79747E"
                      />
                    </svg>{" "}
                    1800 121 6808
                  </div>
                </div>
                <a role="button">
                  <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
                    <path
                      d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
                      fill="#8F8F8F"
                    />
                  </svg>
                </a>
              </li>
              <li onClick={() => copyContent("1800 120 33 2222")}>
                <div className="grid">
                  <label>Sales</label>
                  <div className="message">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                      <path
                        d="M10.0404 8.37377L11.5702 9.90349C11.8076 10.1409 11.8076 10.5258 11.5702 10.7632C10.2867 12.0467 8.25475 12.1911 6.80266 11.102L6.06418 10.5481C4.69501 9.52126 3.47874 8.30499 2.45187 6.93582L1.898 6.19734C0.808938 4.74525 0.953343 2.71332 2.23682 1.42985C2.47422 1.19245 2.85912 1.19245 3.09651 1.42985L4.62623 2.95956C5.01675 3.35008 5.01675 3.98325 4.62623 4.37377L4.18116 4.81884C4.07297 4.92703 4.04615 5.09231 4.11458 5.22916C4.90568 6.81137 6.18863 8.09432 7.77084 8.88542C7.90769 8.95385 8.07297 8.92703 8.18116 8.81884L8.62623 8.37377C9.01675 7.98325 9.64992 7.98325 10.0404 8.37377Z"
                        stroke="#79747E"
                      />
                    </svg>{" "}
                    1800 120 33 2222
                  </div>
                </div>
                <a role="button">
                  <svg width="11" height="12" viewBox="0 0 11 12" fill="none">
                    <path
                      d="M11 4.164C10.9936 4.10888 10.9813 4.05458 10.9633 4.002V3.948C10.934 3.88631 10.8948 3.8296 10.8472 3.78L7.18056 0.18C7.13004 0.13333 7.07228 0.0948486 7.00944 0.0659999C6.9912 0.0634561 6.97269 0.0634561 6.95444 0.0659999C6.89236 0.0310448 6.8238 0.00860652 6.75278 0H4.27778C3.79155 0 3.32523 0.189642 2.98142 0.527208C2.6376 0.864773 2.44444 1.32261 2.44444 1.8V2.4H1.83333C1.3471 2.4 0.880788 2.58964 0.536971 2.92721C0.193154 3.26477 0 3.72261 0 4.2V10.2C0 10.6774 0.193154 11.1352 0.536971 11.4728C0.880788 11.8104 1.3471 12 1.83333 12H6.72222C7.20845 12 7.67477 11.8104 8.01858 11.4728C8.3624 11.1352 8.55556 10.6774 8.55556 10.2V9.6H9.16667C9.6529 9.6 10.1192 9.41036 10.463 9.07279C10.8068 8.73523 11 8.27739 11 7.8V4.2C11 4.2 11 4.2 11 4.164ZM7.33333 2.046L8.91611 3.6H7.94444C7.78237 3.6 7.62693 3.53679 7.51232 3.42426C7.39772 3.31174 7.33333 3.15913 7.33333 3V2.046ZM7.33333 10.2C7.33333 10.3591 7.26895 10.5117 7.15434 10.6243C7.03974 10.7368 6.8843 10.8 6.72222 10.8H1.83333C1.67126 10.8 1.51582 10.7368 1.40121 10.6243C1.28661 10.5117 1.22222 10.3591 1.22222 10.2V4.2C1.22222 4.04087 1.28661 3.88826 1.40121 3.77574C1.51582 3.66321 1.67126 3.6 1.83333 3.6H2.44444V7.8C2.44444 8.27739 2.6376 8.73523 2.98142 9.07279C3.32523 9.41036 3.79155 9.6 4.27778 9.6H7.33333V10.2ZM9.77778 7.8C9.77778 7.95913 9.71339 8.11174 9.59879 8.22426C9.48418 8.33679 9.32874 8.4 9.16667 8.4H4.27778C4.1157 8.4 3.96026 8.33679 3.84566 8.22426C3.73105 8.11174 3.66667 7.95913 3.66667 7.8V1.8C3.66667 1.64087 3.73105 1.48826 3.84566 1.37574C3.96026 1.26321 4.1157 1.2 4.27778 1.2H6.11111V3C6.11111 3.47739 6.30427 3.93523 6.64808 4.27279C6.9919 4.61036 7.45821 4.8 7.94444 4.8H9.77778V7.8Z"
                      fill="#8F8F8F"
                    />
                  </svg>
                </a>
              </li>
            </ul>
            <br />
            If you need further assistance, feel free to ask!
          </div>
        );

        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "Call a purchase assistant",
            sender_type: "user",
          },
          true
        );
        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: ReactDOMServer.renderToString(html),
            sender_type: "agent",
          },
          true
        );

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "Call a purchase assistant",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: html,
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      case "customer_support": {
        // const chtml = sessionData.settings.contact_response;
        // console.log("🚀 ~ submitQue ~ html:", chtml);
        const html = (
          <div className="support">
            <p>
              For after-sales support, service requests, or complaint
              registration, you can reach out to our customer care team, where a
              human customer care executive will assist you. <br />
              <br />
              Note: Customer Care Executives are available Monday-Saturday 9:00
              AM to 6:00 PM.
            </p>
            <SupportHTML />
            <br />
            If you need further assistance, feel free to ask!
          </div>
        );
        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: "Call a purchase assistant",
            sender_type: "user",
          },
          true
        );
        fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/chat-save`,
          {
            session_id: threadId,
            message: ReactDOMServer.renderToString(html),
            sender_type: "agent",
          },
          true
        );

        setMessages((prev) => [
          ...prev,
          {
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{
                  __html: "Contact customer support",
                }}
              />
            ),
            type: "sent",
            time: getCurrentTime(),
          },
          {
            text: html,
            type: "received",
            time: getCurrentTime(),
          },
        ]);
        break;
      }
      default:
        break;
    }
  };

  return (
    <>
      <div className="chatbox-message-item-text mt-2">
        Find Product Information
      </div>
      <ul className="questions">
        <li onClick={() => submitQue("product")}>
          <img src="/agent/elec.svg" />
          <div>Show Products</div>
        </li>
        <li onClick={() => submitQue("brochure")}>
          <img src="/agent/elec.svg" />
          <div>View Product Brochure</div>
        </li>
      </ul>
      <div className="chatbox-message-item-text">Get Help & Assistance</div>
      <ul className="questions">
        <li onClick={() => submitQue("assistant")}>
          <img src="/agent/question.svg" />
          <div>Call a purchase assistant</div>
        </li>
        <li onClick={() => submitQue("customer_support")}>
          <img src="/agent/question.svg" />
          <div>Contact customer support</div>
        </li>
        <li onClick={() => submitQue("dealer")}>
          <img src="/agent/question.svg" />
          <div>Find dealers near me</div>
        </li>
      </ul>
      <div className="chatbox-message-item-text">
        Register Warranty or Service Request
      </div>
      <ul className="questions">
        <li onClick={() => submitQue("warranty")}>
          <img src="/agent/setting.svg" />
          <div>Register for warranty</div>
        </li>
        <li onClick={() => submitQue("service_request")}>
          <img src="/agent/setting.svg" />
          <div>Register a service request</div>
        </li>
      </ul>
    </>
  );
};

function Chatbox() {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");

  const [leadArr, setLeadArr] = useState([]);
  const [leadFormStart, setleadFormStart] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [loader, setLoader] = useState(false);
  const [sessionData, setSessionData] = useState();
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [threadId, setThreadId] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const chatboxRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      // setTimeout(() => {
      //   chatboxRef.current?.classList.add("show");
      // }, 100);
      window.parent.postMessage("openChat", "*");
      if (!threadId) {
        createThread();
      }
    } else {
      // chatboxRef.current?.classList.remove("show");
      // setTimeout(() => {
      window.parent.postMessage("closeChat", "*");
      // }, 300);
    }

    if (token === "essco" && isOpen) {
      const scriptId = "plausible-analytics-script";
      if (!document.getElementById(scriptId)) {
        const s = document.createElement("script");
        s.id = scriptId;
        s.type = "text/javascript";
        s.defer = true;
        s.src =
          "https://plausible.io/js/script.file-downloads.hash.outbound-links.pageview-props.revenue.tagged-events.js";
        s.setAttribute("data-domain", "agilisplus.ai");
        document.getElementsByTagName("head")[0].appendChild(s);
        s.onload = () => {
          window.plausible =
            window.plausible ||
            function () {
              (window.plausible.q = window.plausible.q || []).push(arguments);
            };
        };
      }
    }
  }, [isOpen]);

  useEffect(() => {
    scrollToBottom();
  }, [message]);

  useEffect(() => {
    if (
      messages &&
      messages[messages.length - 1] &&
      messages[messages.length - 1].lead &&
      messages[messages.length - 1].value
    ) {
      startTakingLead();
    }
  }, [messages]);

  const startTakingLead = () => {
    const leadForm = sessionData.settings.lead_form;
    const currentLead = leadForm[leadArr.length];
    if (currentLead) {
      const value =
        sessionData.data.lead && sessionData.data.lead[currentLead.fld_name]
          ? sessionData.data.lead[currentLead.fld_name]
          : "";

      setMessages((prev) => [
        ...prev,
        {
          text: (
            <div
              className=""
              dangerouslySetInnerHTML={{
                __html: currentLead.caption_text,
              }}
            />
          ),
          type: "received",
          lead: true,
          value,
          time: getCurrentTime(),
          ...currentLead,
        },
      ]);
      setLeadArr([...leadArr, ...[leadForm.fld_name]]);
    } else {
      setMessages((prev) => [
        ...prev,
        {
          text: (
            <div
              className=""
              dangerouslySetInnerHTML={{
                __html: sessionData.settings.lead_thanks,
              }}
            />
          ),
          type: "received",
          time: getCurrentTime(),
        },
      ]);
      setleadFormStart(false);
    }
    setTimeout(() => {
      scrollToBottom();
    }, 500);
  };

  useEffect(() => {
    if (
      sessionData &&
      currentQuestionIndex == sessionData.settings.lead_trigger_position
    ) {
      setleadFormStart(true);
      startTakingLead();
    }
  }, [currentQuestionIndex]);

  const saveSession = async (saveSessionResp) => {
    const data = await saveSessionResp.json();
    setLoader(false);
    if (data.data) {
      setSessionData(data);
      if (data.data.chat_messages) {
        const chatM = [];
        for (let index = 0; index < data.data.chat_messages.length; index++) {
          const chat = data.data.chat_messages[index];
          chatM.push({
            text: (
              <div
                className=""
                dangerouslySetInnerHTML={{ __html: chat.message }}
              />
            ),
            type: chat.sender_type === "agent" ? "received" : "sent",
            time: getCurrentTime(chat.createdAt),
          });
        }

        setCurrentQuestionIndex(chatM.length);
        setMessages(chatM.reverse());
      }
    }
  };

  // Create a thread when chat opens
  const createThread = async () => {
    try {
      const threadIDCookie = getCookie(`thread_v1_id_${token}`);
      // console.log("🚀 ~ createThread ~ threadIDCookie:", threadIDCookie);

      // const threadIDCookie = "1234";

      if (!threadIDCookie) {
        const response = await fetch(`${getAPIEndpoint(token)}/create_thread`, {
          method: "POST",
        });
        const data = await response.json();
        if (data.thread_id) {
          setThreadId(data.thread_id);
          setCookie(`thread_v1_id_${token}`, data.thread_id, 1);

          const saveSessionResp = await fetchData(
            token,
            `${getAPIEndpoint(token, true)}/session/session-save`,
            {
              session_id: data.thread_id,
            },
            true
          );
          if (saveSessionResp) saveSession(saveSessionResp);
        }
      } else {
        setLoader(true);
        setThreadId(threadIDCookie);
        setCookie(`thread_v1_id_${token}`, threadIDCookie, 1);
        const saveSessionResp = await fetchData(
          token,
          `${getAPIEndpoint(token, true)}/session/session-save`,
          {
            session_id: threadIDCookie,
          },
          true
        );
        if (saveSessionResp) saveSession(saveSessionResp);
      }
    } catch (error) {
      console.error("Error creating thread:", error);
    }
  };

  const isValid = (text) => text.trim().length > 0;

  // Send message to API
  const handleSendMessage = async (e) => {
    if (e) e.preventDefault();
    if (isValid(message)) {
      const time = getCurrentTime();
      const newMessage = { text: message, type: "sent", time };
      setMessages((prev) => [...prev, newMessage]);
      setMessage("");
      setIsTyping(true);

      fetchData(
        token,
        `${getAPIEndpoint(token, true)}/session/chat-save`,
        {
          session_id: threadId,
          message: message,
          sender_type: "user",
        },
        true
      );
      try {
        const response = await fetch(`${getAPIEndpoint(token)}/chat`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ thread_id: threadId, message }),
        });

        if (response.status === 200) {
          const data = await response.text();
          const respMessage = convertToHTML(data) || "No response received";
          fetchData(
            token,
            `${getAPIEndpoint(token, true)}/session/chat-save`,
            {
              session_id: threadId,
              message: respMessage.htmlString,
              sender_type: "agent",
            },
            true
          );
          setCurrentQuestionIndex(currentQuestionIndex + 1);
          setMessages((prev) => [
            ...prev,
            {
              text: respMessage.html,
              type: "received",
              time: getCurrentTime(),
            },
          ]);
        } else {
          setMessages((prev) => [
            ...prev,
            {
              text: "There is some error during fetching a response.",
              type: "received",
              time: getCurrentTime(),
            },
          ]);
        }

        setIsTyping(false);
        setTimeout(() => {
          scrollToBottom();
        }, 500);
      } catch (error) {
        console.error("Error sending message:", error);
        setMessages((prev) => [
          ...prev,
          {
            text: "There is some error during fetching a response.",
            type: "received",
            time: getCurrentTime(),
          },
        ]);

        setIsTyping(false);
        setTimeout(() => {
          scrollToBottom();
        }, 500);
      }
    }
  };

  const scrollToBottom = () => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  };

  const getCurrentTime = (dateString = null) => {
    const today = dateString ? new Date(dateString) : new Date();

    return (
      String(today.getHours()).padStart(2, "0") +
      ":" +
      String(today.getMinutes()).padStart(2, "0")
    );
  };

  const submitContact = () => {
    // const html = sessionData.settings.contact_response;
    const html = (
      <div className="support">
        <p>Want to get in touch right away?</p>
        <SupportHTML />
      </div>
    );
    setMessages((prev) => [
      ...prev,
      {
        text: html,
        type: "received",
        time: getCurrentTime(),
      },
    ]);

    fetchData(
      token,
      `${getAPIEndpoint(token, true)}/session/chat-save`,
      {
        session_id: threadId,
        message: ReactDOMServer.renderToString(html),
        sender_type: "agent",
      },
      true
    );

    setTimeout(() => {
      scrollToBottom();
      setleadFormStart(true);
      startTakingLead();
    }, 500);
  };

  const zoomBox = () => {
    chatboxRef.current.classList.toggle("zoom");
  };

  var mainlogo = "";
  var chatlogo = "";
  switch (token) {
    case "essco":
      mainlogo = "/agent/essco.png";
      chatlogo =
        "https://www.esscobathware.com/image/catalog/icons/esscofavicon.png";
      break;
    case "haier":
      mainlogo = "/agent/agent/haier_logo_new.png";
      chatlogo = "/agent/agent/haier_white_logo.png";
      break;
    case "glen":
      mainlogo = "/agent/glogo.png";
      chatlogo =
        "https://glenindia.com/cdn/shop/files/Mask_Group_32x32_19424615-95c8-46d8-be5a-2c0f5c8fa21f.webp?v=1726301148";
      break;
    case "acer":
      mainlogo = "https://static-ecapac.acer.com/media/logo/default/acer.png";
      chatlogo =
        "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIACAAIAMBEQACEQEDEQH/xAAZAAEAAgMAAAAAAAAAAAAAAAAAAwYCBQf/xAAjEAABAwMEAwEBAAAAAAAAAAABAgMEABESBSEiMQZBkRQH/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AO40CgUCggmyBEiuPqbW4EC+KLXP0gfTQV2J53pM2Y7AhtS5GotHnDZbC1pTYHIqBKAOQ3y727oMJn9D0CFHalynJDcF1SkIlFq6VKSDcBI5EcTyCcdu6Cw6bOM9lTphyotlWCZKAlSha9wATtv7oINc0WLrbMduUp1BjvB9pTZHFYBANiCD2ewaDVRvCdPiTnp8OXPjzZAtJkNupyfHoKBTjt6sBagwj+BaRHhfgaclJghSCI2SMbIWlYBOOShdI7J2oLVQKBQKBQf/2Q==";
      break;
    case "raymond":
      mainlogo = "/agent/myraymond.png";
      chatlogo =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAMFBMVEVHcEzsGTvtGjvsGTrsGTvsGTrsGTrsGTvsGjvsGjrsGTrsGTvsGTrsGTvsGTvsGTvpB37wAAAAD3RSTlMAMg3QWu+vrR/kvnmVSmrZiMMBAAAAuElEQVQokcWRyQ7DIAxEsQ0N+/z/39YhbFGlKqd2DvZILxmwMeZvolS9FhUZX7UscQ5CbFgA0UYSMk+YAX/2AzjO7oE8MwXBdPhqJkBGclF/h/p1eQI11t2hW7EmAWWHBUhrlCrO8oBsndQ1ynl7W/iCXKy/LcjGkGn8STm8ymKpDz3O1F63JYB2SFi3te4TBvsFuseQOxyvssPYTMQ0A3J20samqGr5Xlx/bl/tZXgWXWG9r+lnegN3tQkF+Fwt6wAAAABJRU5ErkJggg==";
      break;
    default:
      mainlogo = "/agent/myraymond.png";
      chatlogo =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAMFBMVEVHcEzsGTvtGjvsGTrsGTvsGTrsGTrsGTvsGjvsGjrsGTrsGTvsGTrsGTvsGTvsGTvpB37wAAAAD3RSTlMAMg3QWu+vrR/kvnmVSmrZiMMBAAAAuElEQVQokcWRyQ7DIAxEsQ0N+/z/39YhbFGlKqd2DvZILxmwMeZvolS9FhUZX7UscQ5CbFgA0UYSMk+YAX/2AzjO7oE8MwXBdPhqJkBGclF/h/p1eQI11t2hW7EmAWWHBUhrlCrO8oBsndQ1ynl7W/iCXKy/LcjGkGn8STm8ymKpDz3O1F63JYB2SFi3te4TBvsFuseQOxyvssPYTMQ0A3J20samqGr5Xlx/bl/tZXgWXWG9r+lnegN3tQkF+Fwt6wAAAABJRU5ErkJggg==";
      break;
  }

  // console.log("🚀 ~ Chatbox ~ sessionData:", sessionData);
  // console.log("🚀 ~ Chatbox ~ messages:", messages);

  return (
    <div className="chatbox-wrapper">
      {isOpen ? (
        <>
          <div className="chatbox-message-wrapper" ref={chatboxRef}>
            <div className="zoom-button" onClick={() => zoomBox()}>
              <img src="/agent/fullscreen.svg" />
            </div>
            <div className="phone-button" onClick={() => submitContact()}>
              <img src={PhoneIcon} />
            </div>
            <div
              className="close-button"
              onClick={() => setIsOpen((prev) => !prev)}
            >
              <i className="bx bx-x"></i>
            </div>
            <img src={HeaderBG} className="header-icon" />
            <div className="chatbox-message-header">
              <div className="chatbox-message-profile">
                <img src={mainlogo} alt="" className="chatbox-message-image" />
              </div>
            </div>
            {loader ? (
              <div className="chatbox-message-content loader">
                <img src="/agent/loader.svg" />
              </div>
            ) : (
              <>
                <div
                  className={`chatbox-message-content ${
                    leadFormStart ? "m-content" : ""
                  }`}
                  ref={contentRef}
                >
                  {messages.length === 0 ? (
                    <>
                      <div className={`chatbox-message-item received`}>
                        <img
                          src={chatlogo}
                          alt=""
                          className="chatbox-message-image av-image"
                        />

                        <div
                          className="chatbox-message-item-text"
                          dangerouslySetInnerHTML={{
                            __html: getMessage(token),
                          }}
                        />
                        <QuestionsNew
                          message={message}
                          setMessage={setMessage}
                          handleSendMessage={handleSendMessage}
                          token={token}
                          setMessages={setMessages}
                          getCurrentTime={getCurrentTime}
                          sessionData={sessionData}
                          threadId={threadId}
                        />
                        {/* {sessionData &&
                        sessionData.settings &&
                        sessionData.settings.contact_response ? (
                          <>
                            <div className="chatbox-message-item-text">
                              Not really sure about what you want?
                            </div>
                            <ul className="questions">
                              <li onClick={() => submitContact()}>
                                <img src={PhoneIcon} />
                                <div>Call a purchase assistant.</div>
                              </li>
                            </ul>
                          </>
                        ) : null} */}
                      </div>
                      {/* <div className={`chatbox-message-item received`}>
                        <img
                          src={chatlogo}
                          alt=""
                          className="chatbox-message-image av-image"
                        />
                        <Input />
                      </div> */}
                    </>
                  ) : (
                    messages.map((msg, index) => (
                      <div
                        key={index}
                        className={`chatbox-message-item ${msg.type}`}
                      >
                        {msg.type === "sent" ? null : (
                          <img
                            src={chatlogo}
                            alt=""
                            className="chatbox-message-image av-image"
                          />
                        )}

                        {msg.type === "sent" ? (
                          <div className="chatbox-message-item-text">
                            {msg.text}
                          </div>
                        ) : (
                          <>{msg.text}</>
                        )}

                        {msg.lead ? (
                          <Input
                            data={msg}
                            leadArr={leadArr}
                            setMessages={setMessages}
                            messages={messages}
                            startTakingLead={startTakingLead}
                            token={token}
                            threadId={threadId}
                          />
                        ) : null}

                        {/* <span className="chatbox-message-item-time">
                          {msg.time}
                        </span> */}
                      </div>
                    ))
                  )}
                </div>

                {leadFormStart ? null : (
                  <div className="chatbox-message-bottom">
                    {isTyping && (
                      <div className="thinking">
                        <img src="/agent/loading.gif" /> AI is Thinking
                      </div>
                    )}
                    <form
                      className="chatbox-message-form"
                      onSubmit={handleSendMessage}
                    >
                      <input
                        rows="1"
                        placeholder="Go ahead, ask anything else..."
                        className="chatbox-message-input"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                      <button type="submit" className="chatbox-message-submit">
                        <img src={SendIcon} />
                      </button>
                    </form>
                    <div className="powered-by">
                      <div>
                        <span>
                          Our AI is evolving. It can occasionally make mistakes.
                        </span>
                      </div>
                      {/* <div>
                        <span>Powered by &nbsp;&nbsp;&nbsp;</span>
                        <img src="/agent/ag.png" style={{ height: 12 }} />
                      </div>
                      <div>
                        <img src="/agent/en.png" />
                        <span>&nbsp;&nbsp;English</span>
                      </div> */}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="overlay" />
        </>
      ) : (
        <div
          className={`chatbox-toggle ${token}-icon`}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <img src={token === "essco" ? "/agent/essco-help.png" : ChatIcon} />
        </div>
      )}
    </div>
  );
}

export default Chatbox;
